import { Close, FilterAltOffOutlined } from "@mui/icons-material";
import { Button, Grid, IconButton, TextField, useTheme } from "@mui/material";
import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
} from "react";

type Props = {
    filter: any;
    setFilter: Dispatch<SetStateAction<any>>;
};

const initialFilter = {
    // district: "",
    // village: "",
    // hamlet: "",
    meterNo: "",
};

const ReportsFilter = ({ filter, setFilter }: Props) => {
    const currentMonth = new Date().toISOString().slice(0, 7); // YYYY-MM

    const [customerFilter, setCustomerFilter] = useState(initialFilter);
    const theme = useTheme();

    const [date, setDate] = useState({ start: "", end: "", refrence: "" });
    const [applyFilterCount, setApplyFilterCount] = useState(0);

    const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        setDate({ ...date, [e.target.name]: value });
    };

    useEffect(() => {
        setFilter((curr: any) => ({
            ...curr,
            customerFilter,
            dtOpts: {
                start: date.start.split("-").reverse().join(","),
                end: date.end.split("-").reverse().join(","),
                refrence: date.refrence,
            },
        }));
    }, [applyFilterCount]);

    /* ================= CLEAR ALL ================= */

    const handleClearAll = () => {
        // reset UI filters
        // setIntermediateFilter(initialFilter);

        // reset applied filters
        setFilter(initialFilter);
        setCustomerFilter(initialFilter);
        setDate({ start: "", end: "", refrence: "" });
    };

    return (
        <Grid container spacing={2}>
            <Grid item container xs={12} spacing={2}></Grid>

            <Grid item xs={12} md={6} lg={2}>
                <TextField
                    label="Meter No."
                    size="small"
                    name="meterNo"
                    value={customerFilter.meterNo}
                    onChange={(e) =>
                        setCustomerFilter({
                            ...customerFilter,
                            meterNo: e.target.value,
                        })
                    }
                    fullWidth
                />
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
                <TextField
                    label="From Date"
                    type="month"
                    size="small"
                    name="start"
                    value={date.start}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                        min: "2025-10", // ✅ block Sep 2025 and earlier
                        max: currentMonth, // ✅ prevents forward month
                    }}
                    onChange={handleDateChange}
                    fullWidth
                    InputProps={{
                        endAdornment:
                            date.start.length > 0 ? (
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        setDate({ ...date, start: "" });
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            ) : null,
                    }}
                />
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
                <TextField
                    label="To Date"
                    type="month"
                    size="small"
                    name="end"
                    value={date.end}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleDateChange}
                    inputProps={{
                        min: "2025-10", // ✅ block Sep 2025 and earlier
                        max: currentMonth, // ✅ prevents forward months
                    }}
                    fullWidth
                    InputProps={{
                        endAdornment:
                            date.end.length > 0 ? (
                                <IconButton
                                    size="small"
                                    onClick={() =>
                                        setDate({ ...date, end: "" })
                                    }
                                >
                                    <Close />
                                </IconButton>
                            ) : null,
                    }}
                />
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
                <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={() => {
                        console.log("Counter", applyFilterCount);
                        setApplyFilterCount((n) => n + 1);
                    }}
                >
                    search
                </Button>
            </Grid>

            <Grid item xs={12} md={6} lg={2}>
                <Button
                    color="error"
                    variant="outlined"
                    startIcon={<FilterAltOffOutlined />}
                    onClick={handleClearAll}
                    sx={{
                        height: "100%",
                        minWidth: theme.spacing(20),
                    }}
                    fullWidth
                >
                    Clear All
                </Button>
            </Grid>
        </Grid>
    );
};

export default ReportsFilter;
